import beingNamesData from './being-names.json';

/** Pool of quirky British being names, loaded from `being-names.json`. */
export const beingNames = beingNamesData as string[];

/**
 * Returns a random name from the being name pool.
 *
 * @returns A randomly selected "Firstname Surname" string.
 */
export function randomBeingName(): string {
    return beingNames[Math.floor(Math.random() * beingNames.length)];
}
